import { track } from "../../core/App/track";
import { useFormik } from 'formik';
import styled from 'styled-components';
import { Button, FormGroup, Input, VGrid, tombac } from 'tombac';
import { object, ref, string } from 'yup';
import { SetPasswordModes } from "./LoginTypes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormLayout = styled(VGrid).withConfig({
  displayName: "SetPasswordForm__FormLayout"
})(["justify-content:stretch;max-width:", ";"], tombac.space(50));
const validationSchema = object({
  confirmPassword: string().required('Password confirmation is required').oneOf([ref('password')], 'Passwords do not match'),
  password: string().required('Password is required').min(6, 'Password must have at least ${min} characters')
});
const SetPasswordForm = ({
  apiClient,
  query,
  setSubmitted,
  mode
}) => {
  const formik = useFormik({
    initialValues: {
      confirmPassword: '',
      password: ''
    },
    onSubmit: ({
      confirmPassword,
      password
    }) => apiClient.setPassword(password, confirmPassword, query).then(() => {
      if (mode === SetPasswordModes.Register) track('form_submit', {
        category: 'login',
        subcategory: 'activate',
        specificProps: {
          form_type: 'mp_activation',
          visitor_type: 'known',
          account_type: 'move'
        }
      });
      setSubmitted(true);
    }),
    validateOnMount: true,
    validationSchema
  });
  const getFormGroupProps = name => ({
    caption: formik.touched[name] && formik.errors[name],
    danger: Boolean(formik.touched[name] && formik.errors[name])
  });
  const getInputProps = name => ({
    invalid: Boolean(formik.touched[name] && formik.errors[name]),
    name,
    type: 'password',
    ...formik.getFieldProps(name)
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: formik.handleSubmit,
    "data-sentry-component": "SetPasswordForm",
    "data-sentry-source-file": "SetPasswordForm.tsx",
    children: [/*#__PURE__*/_jsxs(FormLayout, {
      "data-sentry-element": "FormLayout",
      "data-sentry-source-file": "SetPasswordForm.tsx",
      "data-sentry-element": "FormLayout",
      children: [/*#__PURE__*/_jsx(FormGroup, {
        htmlFor: "password-input",
        label: "Password",
        ...getFormGroupProps('password'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "SetPasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          id: "password-input",
          ...getInputProps('password'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "SetPasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        htmlFor: "confirm-password-input",
        label: "Confirm password",
        ...getFormGroupProps('confirmPassword'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "SetPasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          id: "confirm-password-input",
          ...getInputProps('confirmPassword'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "SetPasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      })]
    }), /*#__PURE__*/_jsx(VGrid, {
      justifyContent: "stretch",
      $mt: "3sp",
      $w: "25sp",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "SetPasswordForm.tsx",
      "data-sentry-element": "VGrid",
      children: /*#__PURE__*/_jsx(Button, {
        busy: formik.isSubmitting,
        disabled: !formik.isValid,
        type: "submit",
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "SetPasswordForm.tsx",
        "data-sentry-element": "Button",
        children: "Set password"
      })
    })]
  });
};
export default SetPasswordForm;